var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 13L5.41667 10.8333M5.41667 10.8333L13 3.25L20.5833 10.8333M5.41667 10.8333V21.6667C5.41667 21.954 5.5308 22.2295 5.73397 22.4327C5.93713 22.6359 6.21268 22.75 6.5 22.75H9.75M20.5833 10.8333L22.75 13M20.5833 10.8333V21.6667C20.5833 21.954 20.4692 22.2295 20.266 22.4327C20.0629 22.6359 19.7873 22.75 19.5 22.75H16.25M9.75 22.75C10.0373 22.75 10.3129 22.6359 10.516 22.4327C10.7192 22.2295 10.8333 21.954 10.8333 21.6667V17.3333C10.8333 17.046 10.9475 16.7705 11.1506 16.5673C11.3538 16.3641 11.6293 16.25 11.9167 16.25H14.0833C14.3707 16.25 14.6462 16.3641 14.8494 16.5673C15.0525 16.7705 15.1667 17.046 15.1667 17.3333V21.6667C15.1667 21.954 15.2808 22.2295 15.484 22.4327C15.6871 22.6359 15.9627 22.75 16.25 22.75M9.75 22.75H16.25",
    stroke: "#747577",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenu);
export default __webpack_public_path__ + "static/media/homeMenu.12aa5d2044b6b0df580fab60fe264d52.svg";
export { ForwardRef as ReactComponent };